import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, Ref, computed } from 'vue';
import { MessageBox, Message } from 'element-ui';
import logger from '../../tui-room-core/common/logger/logs';
import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';
import { storeToRefs } from 'pinia';
import TUIRoomCore, {ETUIRoomEvents, ETUIRoomRole} from '@/TUIRoom/tui-room-core';
import {LIVE_STAGE} from "@/constants/room";
import {USER_ROLE_MAJOR,USER_ROLE_STARTV} from "@/constants/localKeys";
import {MESSAGE_DURATION} from "@/constants/message";
import { statrRoomResume, forbidRoomResume } from "@/api/lvie";
import {LAYOUT} from "@/constants/render";
import StorageUtils from "@/putils/StorageUtils";

enum DialogType {
  BasicDialog,
  TransferDialog
}

export default /*#__PURE__*/_defineComponent({
  __name: 'EndControl',
  emits: ['on-exit-room', 'on-destroy-room'],
  setup(__props, { emit }) {

const logPrefix = '[EndControl]';

const currentDialogType = ref(DialogType.BasicDialog);



const visible: Ref<boolean> = ref(false);
const basicInfo = useBasicStore();
const {userId, liveStageRoom, userRole,roomId } = storeToRefs(basicInfo);

const roomStore = useRoomStore();
const { remoteAnchorList, localStream } = storeToRefs(roomStore);

const title = computed(() => (currentDialogType.value === DialogType.BasicDialog ? '是否要结束会议' : '请选择新的房间主持人'));

const showLeaveRoom = computed(() => (
  basicInfo.role ===  ETUIRoomRole.MASTER && remoteAnchorList.value.length > 0)
  || basicInfo.role !== ETUIRoomRole.MASTER);

const selectedUser: Ref<string> = ref('');
const roomMember = ref(TUIRoomCore.getRoomUsers());

function resetState() {
  visible.value = false;

  updataLiveStageRoom(LIVE_STAGE.ENDED)
  currentDialogType.value = DialogType.BasicDialog;
}

function stopMeeting() {
  if (!visible.value) {
    visible.value = true;
  }
  // 获取房间里最新成员
  roomMember.value = TUIRoomCore.getRoomUsers();
}

// todo 开始直播 恢复推流cnd
async function startLive() {
  // if (!localStream.value.isAudioStreamAvailable && !localStream.value.isVideoStreamAvailable) {
  //   Message({
  //     type: 'warning',
  //     message: "请开启摄像头或麦克风",
  //     duration: MESSAGE_DURATION.LONG,
  //   });
  //   return;
  // }
  // await TUIRoomCore.startLivePushStream(USER_ROLE_MAJOR);
  console.log("--------开始直播 恢复推流cnd-----------")
  statrRoomResume({roomId:roomId.value,userId:basicInfo.userId}).then(res=>{
    if (res.code == "000"){
      updataLiveStageRoom(LIVE_STAGE.ONGOING)
    }
  }).catch(err=>{
    console.log(err)
    Message({
      type: 'error',
      message: "推流失败，开始直播失败，请重试！",
      duration: MESSAGE_DURATION.LONG,
    });
  });
}

function updataLiveStageRoom(val:any){
  setTimeout(() => {
    basicInfo.setLiveStageRoom(val)
  }, 1000);
}


function cancel() {
  visible.value = false;

  //updataLiveStageRoom(LIVE_STAGE.ENDED)
  currentDialogType.value = DialogType.BasicDialog;

}

function clearCache(){
  // StorageUtils.delRoomSessionCache({roomId:roomId.value,userId:userId.value})
  // window.location.reload()
}

// 主动解散房间
async function dismissRoom() {
  try {
    logger.log(`${logPrefix}dismissRoom: enter`);
    const response = await TUIRoomCore.destroyRoom();
    await TUIRoomCore.logout();
    basicInfo.setLayout(LAYOUT.NINE_EQUAL_POINTS);
    resetState();
    clearCache();
    forbidRoomResume({roomId:roomId.value,userId:basicInfo.userId}).then(res=>{
      if (res.code == "000"){

      }
    }).catch(err=>{
      console.log(err)
      console.log("房间结束失败-----------")
    });
    emit('on-destroy-room', { code: 0, message: '', data: {roomId:roomId.value,userId:userId.value}});
  } catch (error) {
    logger.error(`${logPrefix}dismissRoom error:`, error);
  }
}

// 主动离开房间
async function leaveRoom() { // eslint-disable-line
  try {
    if (basicInfo.role === ETUIRoomRole.MASTER) {
      currentDialogType.value = DialogType.TransferDialog;
      return;
    }
    const response = await TUIRoomCore.exitRoom();
    await TUIRoomCore.logout();
    logger.log(`${logPrefix}leaveRoom:`, response);
    resetState();
    emit('on-exit-room', { code: 0, message: '', data: {roomId:roomId.value,userId:userId.value} });
    clearCache();
  } catch (error) {
    logger.error(`${logPrefix}leaveRoom error:`, error);
  }
}

async function transferAndLeave() {
  if (!selectedUser.value) {
    return;
  }
  try {
    const userIds = selectedUser.value;
    let response = await TUIRoomCore.transferRoomMaster(userIds);
    logger.log(`${logPrefix}transferAndLeave:`, response);
    response = await TUIRoomCore.exitRoom();
    logger.log(`${logPrefix}transferAndLeave:`, response);
    emit('on-exit-room', { code: 0, message: '',  data: {roomId:roomId.value, userId:userId.value}  });
    resetState();
  } catch (error) {
    logger.error(`${logPrefix}transferAndLeave error:`, error);
  }
}

// 收到主持人解散房间通知
const onRoomDestroyed = async () => {
  if (basicInfo.userId === basicInfo.masterUserId) {
    return;
  }
  try {
    MessageBox.alert('主持人结束会议，已解散房间', '通知', {
      confirmButtonText: '确认',
      callback: () => {
        resetState();
        emit('on-destroy-room', { code: 0, message: '',data: {roomId:roomId.value,userId:userId.value} });
        clearCache();
      },
    });
  } catch (error) {
    logger.error(`${logPrefix}onRoomDestroyed error:`, error);
  }
};
// 收到主持人移交权限通知
const onRoomMasterChanged = async (newOwnerID:string) => {
  // 新主持人
  const tipMessage =  `主持人已变更为${newOwnerID}`;
  Message({
    type: 'success',
    message: tipMessage,
  });
  basicInfo.masterUserId = newOwnerID;
  if (basicInfo.userId === basicInfo.masterUserId) {
    basicInfo.role = ETUIRoomRole.MASTER;
  } else {
    roomStore.setRemoteUserRole(newOwnerID, ETUIRoomRole.MASTER);
  }
  resetState();
};

onMounted(() => {
  TUIRoomCore.on(ETUIRoomEvents.onRoomDestroyed, onRoomDestroyed);
  TUIRoomCore.on(ETUIRoomEvents.onRoomMasterChanged, onRoomMasterChanged);
});

onUnmounted(() => {
  TUIRoomCore.off(ETUIRoomEvents.onRoomDestroyed, onRoomDestroyed);
  TUIRoomCore.off(ETUIRoomEvents.onRoomMasterChanged, onRoomMasterChanged);
});


return { __sfc: true,logPrefix, DialogType, currentDialogType, emit, visible, basicInfo, userId, liveStageRoom, userRole, roomId, roomStore, remoteAnchorList, localStream, title, showLeaveRoom, selectedUser, roomMember, resetState, stopMeeting, startLive, updataLiveStageRoom, cancel, clearCache, dismissRoom, leaveRoom, transferAndLeave, onRoomDestroyed, onRoomMasterChanged, ETUIRoomRole, LIVE_STAGE, USER_ROLE_MAJOR }
}

})